/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { Container, Column, Row } from '../../../../styles/Grid';

import Spacer from '../../../ui/Spacer';
import DotComponent from '../../../ui/DotComponent';

import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.style';

import ContentBlock from '../ContentBlock';
import { get } from 'lodash';
import { Picture } from '../../../ui/Picture';
import { CLOUDINARY_BASE_VALUES } from '../../../../utils/constants';
import { Breakpoints } from '../../../../styles/Grid/GridSizes';

const mainImageSizes = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 327,
    height: 248,
    gravity: 'auto:subject',
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 232,
    height: 304,
    gravity: 'auto:subject',
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 376,
    height: 320,
    gravity: 'auto:subject',
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 526,
    height: 400,
    gravity: 'auto:subject',
  },
};

export class FullWidthGrid extends SafePureComponent {
  constructor(props) {
    super(props);
  }
  renderTextBlock = () => {
    const { blockData } = this.props;
    const CTA1Link = get(blockData, 'Cta1Link', '');
    const CTA1Text = get(blockData, 'Cta1Text', '');
    const CTA2Link = get(blockData, 'Cta2Link', '');
    const CTA2Text = get(blockData, 'Cta2Text', '');
    const Heading = get(blockData, 'Heading', '');
    const Subtitle = get(blockData, 'Subtitle', '');
    const ThemeColour = get(blockData, 'ThemeColour', '');
    const Checkbox = get(blockData, 'Checkbox', false);
    return (
      <Column className="leftsec" cols={{ sm: 12, md: 5, lg: 7 }}>
        <ContentBlock
          title={Heading}
          desc={Subtitle}
          textColor={ThemeColour}
          showModal={Checkbox}
          CTA1={{ link: CTA1Link, text: CTA1Text }}
          CTA2={{ link: CTA2Link, text: CTA2Text }}
          LocationInformation={this.props.LocationInformation}
        />
      </Column>
    );
  };

  renderImageBlock = () => {
    const { blockData } = this.props;
    const Image = get(blockData, 'Image', '');

    const imageSrc = {
      value: { src: Image, alt: 'Shop banner' },
    };

    return (
      <Column className="fullwidthcardimgsec" cols={{ sm: 12, md: 3, lg: 5 }}>
        <Row className="imgsec">
          {/* {Image && <img src={Image} alt="banner img" />} */}
          {Image && (
            <Picture
              image={imageSrc}
              imageSizes={mainImageSizes}
              pictureCss={styles.imagefullwidthStyles}
              // pictureCss={previewImageStyleImage}
              editable={false}
            />
          )}
        </Row>
      </Column>
    );
  };

  renderTextImage = () => {
    return (
      <React.Fragment>
        {this.renderTextBlock()}
        {this.renderImageBlock()}
      </React.Fragment>
    );
  };

  renderImageText = () => {
    return (
      <React.Fragment>
        {this.renderImageBlock()}
        {this.renderTextBlock()}
      </React.Fragment>
    );
  };

  safeRender() {
    const { blockData } = this.props;

    const ImagePosition = get(blockData, 'ImagePosition', 'Right');

    const componentStyle =
      ImagePosition === 'Right' ? 'TextImage' : 'ImageText';

    return (
      <Spacer customCss={styles.containerSizesShop}>
        <Container css={[styles.itemsContainerCss]}>
          <Column className="fullwidthgrid">
            {/* <Row className="mdsection" > */}
            <Row className={'mdsection grid-item-1 style-' + componentStyle}>
              {componentStyle === 'ImageText'
                ? this.renderImageText()
                : this.renderTextImage()}
            </Row>
          </Column>
        </Container>
      </Spacer>
    );
  }
}

FullWidthGrid.displayName = 'Shop/FullWidthGrid';

export default withNamespaces()(FullWidthGrid);
